/* eslint-disable @typescript-eslint/no-namespace */

export namespace LgvModel {
    /* ============ User DTO ============ */
    export interface UserDTO {
        id: string;
        email: string;
        firstName: string;
        lastName: string;
        nickName?: string;
        userRoles?: string[];
        ckUserId?: string;
    }

    export interface AgentSS {
        agentInfo: Agent;
        settings: Settings;
        organization: Organization;
        clients?: any;
        company: CompanyInfo;
        roles: string[];
        coBrandedAgent: CoBrandedAgent;
        hasLoanReferral?: boolean;
    }

    export interface AgentDTO {
        agentInfo: Agent_Basic;
        company: CompanyInfo;
        organization: Organization;
        coBrandedAgent?: AgentDTO;
    }

    export interface Agent {
        id: string;
        username: string;
        externalId: string;
        firstName: string;
        lastName: string;
        jobTitle: string;
        nmlsid: string;
        licenseNumber: string;
        userAccessId?: any;
        email: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        phone: string;
        mobilePhone: string;
        fax: string;
        organizationId: string;
        website: string;
        costCenter?: any;
        profileImageUrl: string;
        facebook: string;
        twitter: string;
        google?: any;
        linkedin: string;
        youtube?: any;
        nickName?: any;
        disclaimer?: any;
        basisPoints?: any;
        minAmount?: any;
        maxAmount?: any;
        isDisabled: boolean;
        createdTimestamp: Date;
        updatedTimestamp: Date;
        identityServiceId: string;
        analysisLtvthreshold?: any;
        analysisPaymentSavingThreshold?: any;
        analysisConformingThreshold?: any;
        analysisMipmtSavingThreshold?: any;
        companyId: string;
        yelp?: any;
        instagram?: any;
        zillow?: any;
        applicationUrl?: any;
        enrollmentDate: Date;
        homebotOptIn?: any;
        marginConf?: any;
        minConf?: any;
        maxConf?: any;
        marginHiBal?: any;
        minHiBal?: any;
        maxHiBal?: any;
        marginGovt?: any;
        minGovt?: any;
        maxGovt?: any;
        marginJumbo?: any;
        minJumbo?: any;
        maxJumbo?: any;
        isIlm: boolean;
        lastActivityEmailSentTimestamp: Date;
        myHomeOptInDate: Date;
        isLoinvitationSent: boolean;
        isReadyForPricing: boolean;
        loinvitationSentDate: Date;
        hidePricingForClientView: boolean;
        coBrandingAgentId?: any;
        obchannelIndex: string;
        oboriginatorIndex: string;
        agentSocialMedia?: SocialMedia[];
        billingEntityId: string;
        userApplications?: ApplicationUser[];
        ckUserId?: string;
        stateLicenses: StateLicense[];
    }

    export interface Application {
        id: string;
        type: string;
        name: string;
    }

    export interface ApplicationUser {
        id: string;
        applicationId: string;
        userId: string;
        indexName: string;
        indexValue: string;
        application: Application;
    }

    export interface Agent_Basic {
        id: string;
        firstName: string;
        lastName: string;
        username: string;
        nickName?: any;
        email: string;
        jobTitle: string;
        companyId: string;
        organizationId: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        phone: string;
        mobilePhone: string;
        fax: string;
        website: string;
        profileImageUrl: string;
        facebook: string;
        twitter: string;
        google?: any;
        linkedin: string;
        youtube?: any;
        disclaimer?: any;
        yelp?: any;
        instagram?: any;
        zillow?: any;
        applicationUrl?: string;
        isReadyForPricing: boolean;
        isDisabled?: boolean;
        nmlsid?: string;
    }

    export interface TokenLookupInfo {
        email: string;
        firstName: string;
        lastName: string;
        hasAcceptedTerms: boolean;
        status?: string;
    }

    /* ============ Snapshot and supporting interfaces ============ */

    export interface ClientInfo {
        id: string;
        ownerId: string;
        clientType?: any;
        username?: any;
        firstName: string;
        lastName: string;
        nickName?: any;
        gender: string;
        email: string;
        homePhone?: any;
        workPhone?: any;
        mobilePhone?: any;
        fax?: any;
        birthDate: Date;
        totalIncome: number;
        maritalStatus: string;
        numberDependents: number;
        dependentAges: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        fico?: any;
        isSubscribed: boolean;
        serviceInterest?: any;
        isSilenced: boolean;
        isArchived: boolean;
        isDeleted: boolean;
        externalId: string;
        createdTimestamp: string;
        updatedTimestamp: string;
        identityServiceId: string;
        registeredDate: Date;
        loanId?: string;
        loanInterestRate?: number;
        loanApr?: number;
        loanMonthlyInterestRate?: number;
        loanTerm?: number;
        loanEstimatedBalance?: number;
        equity?: number;
        propertyId?: string;
        propertyAvmestimatedValue?: number;
        propertyAvmhighValue?: number;
        propertyAvmlowValue?: number;
        propertyAvmforecastStandardDeviation?: number;
        propertyAvmprocessedDate?: Date;
        firstTimeBuyer?: boolean;
        monthlyDebt?: number;
        totalDebtPayments?: any;
        owner?: any;
        activities: any[];
        clientGoals: any[];
        clientNonHomeLoans: any[];
        loanApplications: any[];
        //loanScenarios: any[];
        nonHomeLoans: any[];
        opportunities?: any[];
        pricingRequests: any[];
        clientProperties: ClientProperties[];
        isBeta?: boolean;
    }

    export interface LoanInfo {
        alreadyRefinanced: boolean;
        alreadyRefinancedAnotherLender: boolean;
        alreadySold: boolean;
        amortTerm: number;
        amortizationTypeId: string;
        appraisalDate?: any;
        appraisedValue: number;
        apr: number;
        armadjustmentCap: number;
        armfirstAdjustmentCap: number;
        armfirstChangeMonths: number;
        armindex: number;
        armlifeCap: number;
        armmargin: number;
        clientEstimatedBalance?: number;
        clientEstimatedBalanceUpdatedTimestamp?: string;
        clientInterestRate?: number;
        clientLoan?: any[];
        clientMonthlyMortgageInsurance?: number;
        clientPurchasePrice?: number;
        closingDate: string;
        createdTimestamp: string;
        earlyPayoffDate?: any;
        externalId: string;
        externalLoanSource?: any;
        firstAdjustmentCap: number;
        firstInterestChangeDate?: any;
        firstPaymentDate: string;
        floodInsurance: number;
        hazardInsurance: number;
        hazardInsuranceCompany: string;
        hoadues?: any;
        homeSize?: any;
        hudescrowMonthlyPayment: number;
        id: string;
        indexTypeCode: string;
        indexValue: number;
        interestAdjustPeriod: number;
        interestRate: number;
        isActive: boolean;
        lastPaymentDate: string;
        lenderCaseNumber: string;
        lenderNmlsid: string;
        lienTypeId: string;
        lifeFloor: number;
        lifeTimeCap: number;
        lmcreditScore: number;
        loanNumber: string;
        loanPurposeTypeId: string;
        loanTerm: number;
        loanTypeId: string;
        lotSize?: any;
        ltv: number;
        monthlyMortgageInsurance?: any;
        monthlyPayment: number;
        nmlsid: string;
        nmlsloanTypeId: string;
        numberOfBath?: any;
        numberOfBedroom: number;
        otherLoanBalance?: number;
        parcelNumber: string;
        periodicCap: number;
        programId: string;
        propertyId: string;
        propertyTypeId: string;
        purchaseDate: string;
        purchasePrice: number;
        purposeRefinanceTypeId: string;
        refinanceTypeId?: any;
        residenceTypeId: string;
        respaApplicationDate: string;
        sellersAgentAddress: string;
        sellersAgentCity: string;
        sellersAgentCompany: string;
        sellersAgentCompanyLicenseNumber: string;
        sellersAgentEmail: string;
        sellersAgentLicenseNumber: string;
        sellersAgentName: string;
        sellersAgentPhone: string;
        sellersAgentState: string;
        sellersAgentZip: string;
        settlementCompany: string;
        subjectPropertyAddress: string;
        subjectPropertyCity: string;
        subjectPropertyState: string;
        subjectPropertyZip: string;
        totalLoanAmount: number;
        totalMargin: number;
        totalMonthlyPayment: number;
        updatedTimestamp: string;
        upfrontMipPercentage: number;
        yearAcquired: number;
        yearBuilt?: any;
        lastPublicRecordConfirmDate: string;
    }

    export interface PropertyInfo {
        id: string;
        address: string;
        city: string;
        state: string;
        zip: string;
        propertyTypeId: string;
        yearBuilt?: any;
        parcelNumber: string;
        coreLogicPropertyId?: any;
        county?: any;
        ownerName?: any;
        avmestimatedValue?: number;
        avmlowValue?: any;
        avmhighValue?: any;
        avmprocessedDate?: any;
        avmforecastStandardDeviation?: any;
        apn?: any;
        landUse?: any;
        landUseCode?: any;
        censusTract?: any;
        absenteeOwner?: any;
        latitude?: any;
        longitude?: any;
        standardLandUse?: any;
        standardLandUseCode?: any;
        source: string;
        avmProvider?: any;
        livingArea?: any;
        totalRooms?: any;
        bedrooms: number;
        fullBath?: any;
        halfBath?: any;
        totalBaths?: any;
        pool?: any;
        numberOfStories?: any;
        lotArea?: any;
        effectiveYearBuilt?: any;
        airConditioning?: any;
        fireplace?: any;
        parking?: any;
        createdTimestamp: string;
        lastPublicRecordCheckupDate: string;
        salePrice?: any;
        propertyType?: any;
        taxYear?: any;
        propertyTax?: any;
        assessedValue?: any;
        neighborhoodName?: any;
        schoolDistrict?: any;
        elementarySchool?: any;
        middleSchool?: any;
        highSchool?: any;
        saleDate?: string;
        listingPrice?: any;
    }

    export interface PropertyType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface SalesHistory {
        id: string;
        propertyId: string;
        salePrice: number;
        recordingDate: Date;
        saleDate: Date;
        saleType: string;
        sellerName: string;
        firstMortgageAmount: number;
        firstMortgageType: string;
        secondMortgageAmount: number;
    }

    export interface TaxHistory {
        id: string;
        propertyId: string;
        assessedValue: number;
        assessedYear: number;
        landValue: number;
        improvementValue: number;
    }

    export interface Property {
        propertyInfo: PropertyInfo;
        propertyType: string;
        loans: Loan[];
        salesHistory?: SalesHistory[];
        taxHistory?: TaxHistory[];
        associationType: string;
        loanScenarios: LoanScenario[];
        pricingStatus?: string;
        isPrimaryProperty: boolean;
        clientPropertyAdjustments?: PropertyAdjustments[];
        isSelected?: boolean; // UI Only
    }

    export interface LoanScenario {
        id: string;
        createdOn: string;
        updatedOn: string;
        purchasePrice: number;
        downPayment: number;
        loanAmount: number;
        payDownPoints: boolean;
        residenceType: string;
        client?: any;
        property?: any;
        opportunities?: any;
        pricingRequests?: any;
    }

    export interface LoanAnalysis {
        id: string;
        loanId: string;
        ownerId: string;
        creditScore: number;
        loanOrigination: string;
        closedDate: string;
        interestRate: number;
        monthlyInterestRate: number;
        totalMortgageLoanAmount: number;
        appraisalValue: number;
        loanPurpose: string;
        loanTerm: number;
        loanType: string;
        progType: string;
        ownerOccupied: string;
        ltv: number;
        ltvthreshold: number;
        analysisPaymentSavingThreshold: number;
        analysisConformingThreshold?: any;
        analysisMipmtSavingThreshold?: any;
        armfirstAdjustmentDate?: any;
        monthlyPaymentMi: number;
        monthsAgoClosed: number;
        loanPayment: number;
        payment: number;
        balanceNeededForLtv: number;
        totalInterest: number;
        totalPrincipal: number;
        estimatedBalance: number;
        deltaToLtv: number;
        monthsToLtv: number;
        monthForLtv: string;
        deltaToConforming?: any;
        monthsToConforming: number;
        monthForConforming: string;
        notEligibleForOpportunity: boolean;
        estimatedLtv: number;
        marketMonthlyPaymentMi?: any;
        totalPaymentWithMi: number;
        estimatedCashOutLimit?: any;
        estimatedHomeValue?: any;
        pricingId?: string;
        matchedPrice?: number;
        matchedRate?: number;
        fhatoConvPricingId?: any;
        fhatoConvMatchedPrice?: any;
        fhatoConvMatchedRate?: any;
        marketPayment?: number;
        paymentSavings?: number;
        fhatoConvMarketPayment?: number;
        fhatoConvPaymentSavings?: number;
        mipaymentSavings?: number;
        fhatoConvPaymentSavingsWithMi?: number;
        armnewInterestRate?: any;
        armnewPayment?: any;
        armnewPaymentSavings?: any;
        yearToDatePrincipal: number;
        yearToDateInterest: number;
        lastYearPrincipal: number;
        lastYearInterest: number;
        remainingPrincipal: number;
        remainingInterest: number;
        monthsSinceLastDataTraceCheckup: number;
    }

    export interface PropertyAdjustments {
        id: string;
        adjustmentValue: number;
        clientPropertyId: string;
        adjustmentTypeId: string;
        avmAdjustmentReasonId: string;
        modifiedBy: string;
        modifiedByType: string;
        createdTimestamp: string;
        updatedTimestamp: string;
        adjustmentType: AdjustmentType;
        clientProperty: null;
        renovationType: RenovationType;
    }

    export interface AdjustmentType {
        id: string;
        name: string;
        clientPropertyAdjustments: any[];
    }

    export interface RenovationType {
        id: string;
        name: string;
    }

    export interface LoanPurposeType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface PurposeRefinanceType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface RefinanceType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface LienType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface AmortizationType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface Program {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface LoanType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface NmlsloanType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface PropertyType2 {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface ResidenceType {
        id: string;
        name: string;
        lgvcode: string;
        displayOrder: number;
        companyId: string;
    }

    export interface Loan {
        loanInfo: LoanInfo;
        //property: Property;
        loanAnalysis: LoanAnalysis;
        loanPurposeType: LoanPurposeType;
        purposeRefinanceType: PurposeRefinanceType;
        refinanceType: RefinanceType;
        lienType: LienType;
        amortizationType: AmortizationType;
        program: Program;
        loanType: LoanType;
        nmlsloanType: NmlsloanType;
        propertyType: PropertyType2;
        residenceType: ResidenceType;
        opportunities?: Opportunity[];
        isSelected?: boolean; // ** UI Only **
    }

    export interface PricingAdjustment {
        key: string;
        adj: string;
    }

    export interface GroupPricingAdjustment {
        id: string;
        finalAdjustment: number;
        adjustments: PricingAdjustment[];
    }

    export interface OpportunityInfo {
        id: string;
        createdTimeStamp: Date;
        clientId: string;
        loanId?: string;
        loanScenarioId?: string;
        pricingScenarioId?: string;
        opportunityTypeId: string;
        paymentSavingThreshold: number;
        paymentSavings?: number;
        mipmtSavingThreshold: number;
        mipaymentSavings: number;
        ltvthreshold: number;
        lockPeriod: number;
        estimatedLtv: number;
        conformingThreshold: number;
        estimatedBalance: number;
        matchedApr: number;
        matchedRate: number;
        matchedPrice: number;
        marketPayment: number;
        marketMonthlyPaymentMi: number;
        loanTermMonths: number;
        loanTypeName: string;
        productCode: string;
        productName: string;
        productIndex: string;
        amortizationTypeName: string;
        loanAmount: number;
        armfixedTermMonths?: number;
        priceStatus: string;
        points?: number;
        pointsCost?: number;
        closingCost?: number;
        feeDetails?: FeeDetail[];
        armmargin?: number;
        armindexName?: string;
        armindexValue?: number;
        armfirstCap?: number;
        armlifetimeCap?: number;
        armperiodicCap?: number;
        armsubsequentChangePeriod?: number;
        groupAdjustmentProperties?: GroupPricingAdjustment[];
        investor?: string;
        loanPurpose?: string;
        quoteId?: string;
    }

    export interface FeeDetail {
        amount: number;
        description: string;
        isOrigination: boolean;
        points: number;
        type: string;
    }

    export interface OpportunityType {
        id: string;
        name: string;
    }

    export interface Opportunity {
        opportunityInfo: OpportunityInfo;
        opportunityType: OpportunityType;
        isSelected?: boolean;
        propertyAssociationType?: string;
        property?: LgvModel.Property; // ** UI Only **
    }

    export interface ClientSnapshot {
        clientInfo: ClientInfo;
        goals: Goal[];
        //loans: Loan[];
        properties: Property[];
        settings: Settings;
        scenarios?: any[];
        hasLoanApplication?: boolean;
    }

    export interface ClientDTO {
        id: string;
        ownerId: string;
        clientType?: any;
        username?: any;
        firstName: string;
        lastName: string;
        nickName: string;
        gender: string;
        email: string;
        homePhone: string;
        workPhone: string;
        mobilePhone: string;
        fax?: any;
        birthDate?: Date;
        totalIncome?: number;
        maritalStatus: string;
        numberDependents?: number;
        dependentAges: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        fico?: number;
        isSubscribed: boolean;
        serviceInterest?: any;
        isSilenced: boolean;
        isArchived: boolean;
        isDeleted: boolean;
        externalId: string;
        createdTimestamp: Date;
        updatedTimestamp?: Date;
        identityServiceId?: any;
        registeredDate?: any;
        loanId: string;
        loanInterestRate?: number;
        loanApr?: number;
        loanMonthlyInterestRate?: number;
        loanEstimatedBalance?: number;
        loanTerm?: number;
        equity?: number;
        propertyId: string;
        propertyAvmestimatedValue?: number;
        propertyAvmhighValue?: number;
        propertyAvmlowValue?: number;
        propertyAvmforecastStandardDeviation?: number;
        propertyAvmprocessedDate?: Date;
        clientEstimatedValue?: any;
        clientEstimatedValueDelta?: any;
        clientEstimatedValueUpdatedBy?: any;
        adjustedMarketValue?: number;
        clientEstimatedBalance?: number;
        clientInterestRate?: number;
        clientPurchasePrice?: number;
    }

    /* ============ Other ============ */
    export interface BusinessType {
        displayOrder: number;
        id: string;
        name: string;
    }

    export interface CompanyConfig {
        displayName: string;
        appName: string;
        code: string;
        //clientID: string;  kxk: todo  Not sure if this was ever populated
        domain: string;
        audience: string;
        urlKey: string;
        appUrl: string;
        googleTrackingID: string;
        applyNowBaseUrl: string;
        isRealtor: boolean;
        companyCSSClass: string;
        colorScheme: string[];
        agentFooterLogoUrl: string;
        isDepreciated?: boolean;
    }

    export interface CompanyInfo {
        id: string;
        businessTypeId: string;
        businessTypeName: string;
        name: string;
        dbaname?: any;
        address1?: any;
        address2?: any;
        city?: any;
        state?: any;
        zipCode?: any;
        phone?: any;
        fax?: any;
        website?: any;
        nmlsid: string;
        licenseNumber?: any;
        companyLogoUrl?: any;
        companyEmail?: any;
        disclaimer?: any;
        isDisabled?: boolean;
        externalId?: string;
        createdTimestamp?: Date;
        updatedTimestamp?: any;
        companyCode: string;
        lenderPartnerId?: string;
        //lenderPartnerId?: string;
        lenderPartnerCompanyId?: string;
        lenderPartnerCompanyName?: string;
        companySocialMedia?: SocialMedia[];
        applicationCompanies?: ApplicationCompany[];

        userCount?: number;
        clientCount?: number;

        // Need added kxk: todo
        //**** Need these added ****
        baseUrl?: string;
        appName?: string;
        googleTrackingId?: string;
        applyNowBaseUrl?: string;
        stateLicenses?: StateLicense[];
    }

    export interface ApplicationCompany {
        id: string;
        applicationId: string;
        type: string;
        name: string;
    }

    export interface CompanyBranding {
        assets: BrandingAsset[];
        attributes: BrandingAttribute[];
        disclosures: Disclosure[];
    }

    export interface FullCompanyInfo {
        companyInfo?: CompanyInfo;
        brandingInfo?: CompanyBranding;
    }

    export interface ClientDisclosures {
        agentDisclosures: AgentDisclosures;
        coBrandedAgentDisclosures: AgentDisclosures;
    }

    export interface AgentDisclosures {
        agentId: string;
        companyCode: string;
        companyId: string;
        disclosures: Disclosure[];
    }

    export interface Disclosure {
        id: string;
        typeId: string;
        type?: string;
        title?: string;
        value?: string;
        displayOrder: number;
        isForCobrandedClientOnly?: boolean;
        contentLocations: ContentLocation[];
    }

    export interface ContentLocation {
        id: string;
        name: string;
    }

    export interface BrandingAsset {
        name: string;
        completeName: string;
        url: string;
    }

    export interface BrandingAttribute {
        id?: string;
        brandingAttributeId: string;
        code: string;
        name: string;
        value: string;
        description?: string;
        displayOrder?: number;
        hideInUI?: boolean;
    }

    export interface SocialMedia {
        socialMediaTypeId: string;
        url: string;
    }

    export interface Activity {
        id: string;
        clientId: string;
        activityTypeId: string;
        activityTimestamp: string;
        createdTimestamp: Date;
        notes: string;
    }

    export interface Message {
        messageTypeId: string;
        message: string;
    }

    export interface ActivityVM {
        id: string;
        clientId: string;
        activityTypeId: string;
        activityTimestamp: Date;
        activityTypeName: string;
        clientEmail: string;
        clientFirstName: string;
        clientLastName: string;
        agentId: string;
        agentFirstName: string;
        agentLastName: string;
        createdTimestamp: Date;
        notes: string;
    }

    export interface ActivityType {
        id: string;
        name: string;
        displayOrder: number;
        companyId: string;
    }

    export interface Goal {
        id: string;
        description: string;
        displayOrder: number;
        enabled: boolean;
    }

    export interface UserToken {
        type: string;
        guidStr: string;
    }

    export interface MarketValueHistory {
        //propertyId: string;
        estimatedValue: number;
        lowValue: number;
        highValue: number;
        processedDate: string;
        forecastStandardDeviation?: number;
        confidence?: number;
        processedMonth: number;
        processedYear: number;
        processedPeriod: string;
    }

    export interface Organization {
        id: string;
        name: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        phone: string;
        fax: string;
        nmlsid: string;
        licenseNumber?: any;
        organizationLogoUrl?: any;
        organizationEmail?: any;
        disclaimer: string;
        companyId: string;
        isDisabled: boolean;
        externalId: string;
        createdTimestamp: Date;
        updatedTimestamp?: any;
        applications: ApplicationOrganization[];
    }

    export interface ApplicationOrganization {
        id?: string;
        applicationId: string;
        organizationId: string;
        indexName: string;
        indexValue: string;
    }

    export interface Page {
        key: string;
        title: string;
        description: string;
        displayOrder: number;
        isVisible: boolean;
        isNavigationPage?: boolean;
    }

    export interface Settings {
        pages: Page[];
        hidePricingForClientView?: boolean;
    }

    export interface CoBrandedAgent {
        agentInfo: Agent_Basic;
        company: CompanyInfo;
        organization: Organization;
    }

    export interface StateLicense {
        expirationYear: number;
        state: string;
        stateLicenseNumber: string;
        status: string;
    }

    export interface UpdateStateLicenseRequest extends StateLicense {
        id: string;
    }

    export interface Role {
        code: string;
        description: string;
        displayName: string;
        displayOrder: number;
    }

    export interface Assistant {
        id: string;
        alertWhenEmailSent: boolean;
        firstName: string;
        lastName: string;
        jobTitle: string;
        address1: string;
        address2?: any;
        city: string;
        state: string;
        zipCode: string;
        phone: string;
        mobilePhone: string;
        fax: string;
        profileImageUrl: string;
        email: string;
    }

    export interface HomeVaultDocumentAttachment {
        entityId: string;
        entityType: string;
        entityName: string;
    }

    export interface HomeVaultDocument {
        documentId: string;
        title: string;
        description: string;
        receivedBy: string;
        dateReceived: string;
        attachments: HomeVaultDocumentAttachment[];
    }

    export interface InsuranceDeductibles {
        general: number;
        hurricane?: any;
        windAndHail?: any;
    }

    export interface InsuranceCoverages {
        a: number;
        b: number;
        c: number;
        d: number;
        e: number;
        f: number;
        waterBackup: number;
        homeOffice: number;
        computers: number;
        jewelry: number;
        personalPropertyReplacementCost: boolean;
        serviceLine: number;
        mortgagePaymentProtection: boolean;
        equipmentBreakdown: number;
        lossAssessment: number;
        ordinanceOrLaw: number;
        acvOnRoof: boolean;
        sinkholeCollapse?: any;
    }

    export interface InsuranceQuote {
        success: boolean;
        messages: any[];
        errors?: any;
        quoteId: string;
        quoteUrl: string;
        premium: number;
        deductibles: InsuranceDeductibles;
        coverages: InsuranceCoverages;
    }

    export interface Activity {
        activityName: string;
        count: number;
        isHot: boolean;
    }

    export interface Client {
        clientId: string;
        clientFirstName: string;
        clientLastName: string;
        loanAgentId: string;
        loanAgentFirstname: string;
        loanAgentLastName: string;
        loanAgentCompanyId: string;
        loanAgentCompanName: string;
        realtorId?: any;
        realtorFirstName?: any;
        realtorLastName?: any;
        realtorCompanyId?: any;
        realtorCompanyName?: any;
        address: string;
        city?: any;
        state: string;
        zip: string;
        equity: number;
        equityPercent: number;
        rate: number;
        loanTerm: number;
        lienType: string;
        closingDate: Date;
        isCobrandedClient: boolean;
        latestActivityTimestamp: Date;
        relevantCount: number;
        activitiesCount: number;
        activities: Activity[];
    }

    export interface ClientActivities {
        // totalActivities: number;
        // totalEmailsSent: number;
        // totalClientVisits: number;
        // clients: Client[];
        count: number;
        value: Client[];
    }
    export interface Equity {
        loanId: string;
        propertyId: string;
        isActive: boolean;
        alreadyRefinanced: number;
        closingDate: Date;
        firstPaymentDate: Date;
        loanPurpose: string;
        lienType: string;
        loanType: string;
        totalLoanAmount: number;
        interestRate: number;
        appraisedValue: number;
        currentEstimatedHomeValue: number;
        estimatedBalance: number;
        combinedLoanBalance: number;
        isPrimaryBorrower: boolean;
        clientId: string;
        borrowerName: string;
        firstName: string;
        lastName: string;
        isSilenced: boolean;
        address: string;
        city: string;
        state: string;
        zip: string;
        agentName: string;
        companyName: string;
        sumEstimatedBalances: number;
        externalLoanSource: string;
        createdtimestamp: Date;
        updatedTimestamp?: any;
        maxAppraisedAtClosingDate: number;
        sumCombinedLoanAmount: number;
        currentEquity: number;
        currentEquityPercent?: number;
        currentLtv: number;
        closingDateEquity: number;
        closingDateEquityPercent: number;
        closingLtv: number;
        deltaEquity: number;
        deltaEquityPercent: number;
        isSignificantEquity: number;
        clientRank: number;
    }

    export interface ClientProperties {
        clientId?: string;
        createdTimeStamp?: string;
        id?: string;
        propertyAssociationTypeId?: string;
        propertyId?: string;
        residenceType?: string;
        residenceTypeId?: string;
        updatedTimeStamp?: string;
        listingPrice?: number;
        property?: PropertyInfo;
        pricingStatus?: any;
        pricingStatusId?: string;
    }

    export class LoanObject {
        loan: Loan;
        loanScenario: LoanScenario;
        get isLoan(): boolean {
            return this.loan !== null;
        }
        get isLoanScenario(): boolean {
            return this.loanScenario !== null;
        }
        get id(): string {
            return this.isLoan ? this.loan.loanInfo.id : this.loanScenario.id;
        }
    }

    export interface UserInviteModel {
        assignedCompanyId: string;
        firstName: string;
        lastName: string;
        email: string;
    }

    export class GenericProviderData {
        provider: string;
        providerType: string;
        settings?: any;
    }

    export class PricingProviderSettings {
        channelIndex?: string;
        originatorIndex?: string;
        maxFee?: string;
        targetPrice?: string;
        loanAgentId?: string;
    }

    export class locationInfo {
        city: string;
        county: string;
        id: string;
        postalCode: string;
        state: string;
        stateCode: string;
    }

    export interface RealtorRegistration {
        cobrandedAgentId: string;
        firstName: string;
        lastName: string;
        email: string;
        password: string;
        companyName: string;
    }

    export interface NameValueDTO {
        name: string;
        value: string;
    }

    export interface SelectedProperty {
        streetAddress: string;
        city: string;
        state: string;
        zipCode: string;
        county: string;
        propertyId: string;
    }

    export interface ClientSearchSummary {
        count: number;
        value: ClientInfo[];
    }

    export function agentSSToAgentDTO(ss: LgvModel.AgentSS): LgvModel.AgentDTO {
        return {
            agentInfo: ss.agentInfo,
            company: ss.company,
            organization: ss.organization,
            coBrandedAgent: ss.coBrandedAgent
        };
    }
}
